module.exports = __webpack_public_path__ + "static/daeyoung.won-17abb4275bd4b4f06aec62b810df2023.jpeg";